export default () => {
  $('#changepassword-button').prop('disabled', true);
  $('#password, #password_confirm').on('keyup', function () {
    if ($('#password').val() !== '' && $('#password').val() == $('#password_confirm').val()) {
      $('#message').html('Matching').css('color', 'green');
      $('#changepassword-button').prop('disabled', false);
    } else {
      $('#changepassword-button').prop('disabled', true);
      $('#message').html('Not Matching').css('color', 'red');
    }
  });
}
